class HbsIslemtanimDTO {
    id: number = null;
    kodu?: string = "";
    adi?: string = "";
    grupId?: number = null;
    aktif?: string = "E";
    aktifBool?: boolean = true;
    islemadet?: number = null;
    entLoincKodu?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    entPanel?: string = "H";
    entPanelBool?: boolean = false;
    faturaKodu?: string = "";
    kdvoran?: number = 0;
    paketKodu?: string = "";
    analizaciklama?: string = "";
    adetsor?: string = "H";
    adetsorBool?: boolean = false;
    faturaPuan?: number = null;
    islemTanimTipIp?: number = null;
    gensecimDurum?: string = "Y";
    minGenSayisi?: number = null;
    maxGenSayisi?: number = null;
    genkodliste?: string = "";
    huvBirim?: number = null;
    islemtanimtipId?: number = 1; //GNL_PARAMETRE_GRUP.ID = 73
    disEntegrasyonKodu?: string = "";
    sutkod?: string = "";
    faturaAdi?: string = "";
    kotaGun?: number = null;
    sonucDegerleri?: number = null;
}
export default HbsIslemtanimDTO;